import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorPage.css';
import { usePageSEO } from '../hooks/useSEO';

interface ErrorPageProps {
  errorCode?: string;
  title?: string;
  message?: string;
  showHomeButton?: boolean;
  showBackButton?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  errorCode = '404',
  title = 'Page Not Found',
  message = 'The page you\'re looking for doesn\'t exist or has been moved.',
  showHomeButton = true,
  showBackButton = true
}) => {
  const navigate = useNavigate();

  // Apply error page SEO
  usePageSEO('home', {
    title: `${errorCode} - ${title} | StudyMind`,
    description: message
  });

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="error-page">
      <div className="error-container">
        {/* Brand */}
        <div className="error-brand">
          <span className="error-brand-icon">🧠</span>
          <span className="error-brand-text">StudyMind</span>
        </div>

        {/* Error Content */}
        <div className="error-content">
          <div className="error-number">{errorCode}</div>
          <h1 className="error-title">{title}</h1>
          <p className="error-description">{message}</p>
        </div>

        {/* Actions */}
        <div className="error-actions">
          {showHomeButton && (
            <button className="error-btn error-btn-primary" onClick={handleGoHome}>
              Go Home
            </button>
          )}
          {showBackButton && (
            <button className="error-btn error-btn-secondary" onClick={handleGoBack}>
              Go Back
            </button>
          )}
        </div>

        {/* Support */}
        <div className="error-links">
          <span className="error-links-label">Need help?</span>
          <a href="mailto:admin@study-mind.com" className="error-support-email">
              admin@study-mind.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage; 